export interface HeaderDay {
    title: string,
    weekend: boolean
}

export interface CalendarDay extends HeaderDay {
    date: Date,
    current: boolean,
    out: boolean,
    selected: boolean
}

export interface WeekInfo {
	/** An integer between 1 (Monday) and 7 (Sunday) indicating the first
	 * day of the week for the locale. Commonly 1, 5, 6, or 7. */
	firstDay: number;
	/** An array of integers between 1 and 7 indicating the weekend days for the locale.
	 * This is usually continuous because UTS 35 stores weekendStart and weekendEnd instead. */
	weekend: number[];
	/** An integer between 1 and 7 (commonly 1 and 4) indicating the minimal days required
	 * in the first week of a month or year, for week-of-year or week-of-month calculations
	 * (e.g. The 20th week of the year). For example, in the ISO 8601 calendar, the first
	 * week of a year must have at least 4 days in this year, so if January 1 is a Friday,
	 * Saturday, or Sunday, it will be numbered as part of the last week of the previous year. */
	minimalDays: number;
}

export function weekInfo():WeekInfo {
	// Server is the source of the truth, not client (caused undeterministic behavior)
	// const locale = new Intl.Locale(navigator.language);
	// if (locale.weekInfo) {
	// 	return locale.weekInfo as WeekInfo;
	// }

	return {
		firstDay: Server.calendar.firstDayOfWeek === 0 ? 7 : 1 /* 1 = monday, 7 = sunday */,
		weekend: [6, 7],
		minimalDays: 4,
	};
}